module.exports = __webpack_public_path__ + "img/banner3.aed01e47.webp";